import router from '@/router/router'
import axios from 'axios'

import moment from 'moment'

const state = {
  jwt: {
    token: null,
    expires_at: null,
  },
  user: null,
}

const getters = {
  authCheck(state) {
    return state.jwt.token !== null
  },
  guest(state) {
    return state.jwt.token === null
  },
  
  token(state) {
    return state.jwt.token
  },
  
  user(state) {
    return state.user
  }
}

const mutations = {
  
  /**
   * @param state
   * @param data
   * data {token - required, expires_at - optional, expires_in - required if expires_at is not set}
   */
  storeJwt(state, data) {
    
    state.jwt.token = data.token
    state.jwt.expires_at = data.expires_at ? data.expires_at : (new Date).valueOf() + (data.expires_in * 1000)
    
    localStorage.jwt_token = state.jwt.token
    localStorage.jwt_expires_at = state.jwt.expires_at
  },
  
  storeUser(state, user) {
    state.user = user
  },
  
  clearAuthData(state) {
    state.jwt = {token: null, expires_at: null}
    state.user = null
    delete localStorage.jwt_token
    delete localStorage.jwt_expires_at
  }
  
}

const actions = {
  
  /**
   * Data contains email and password
   * @param commit
   * @param dispatch
   * @param data
   */
  login({commit, dispatch}, data) {
    return new Promise((resolve, reject) => {
      axios.post('/login', data).then(response => {
        const token = response.data.access_token
        const expires_in = response.data.expires_in
        
        commit('storeJwt', {token, expires_in})
        dispatch('setTimerForTokenRefresh', expires_in)
        dispatch('fetchUser').then(() => {
          resolve()
        })
        
      }).catch(err => {
        reject(err)
      })
    })
  },
  
  fetchUser({commit}) {
    return axios.post('/me')
      .then(res => commit('storeUser', res.data))
      .catch(error => console.log(error))
  },
  
  tryToRefreshToken({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.post('/refresh')
        .then(res => {
          const token = res.data.access_token
          const expires_in = res.data.expires_in
          
          if (token && expires_in) {
            commit('storeJwt', {token, expires_in})
            dispatch('setTimerForTokenRefresh', expires_in)
            dispatch('fetchUser').then(() => {
              resolve()
            })
          } else {
            dispatch('logout')
          }
        })
        .catch(error => {
          dispatch('logout')
          reject()
        })
    })
  },
  
  tryToLoginFromLocal({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      
      let token = localStorage.jwt_token || null
      let expires_at = localStorage.jwt_expires_at || null
      
      if (token && expires_at) {
        
        let now = (new Date).valueOf()
        let expires_in = (expires_at - now) / 1000
        console.log('Session expires in ' + expires_in + ' seconds')
        
        if (60 > expires_in && expires_in > 0) {
          dispatch('tryToRefreshToken').then(() => {
            return resolve()
          }).catch(err => {
            return reject()
          })
        } else if (0 > expires_in) {
          dispatch('logout')
          return reject()
        }
        
        commit('storeJwt', {token, expires_at})
        dispatch('fetchUser').then(() => {
          resolve()
        })
        
      }
      
      reject()
      
    })
  },
  
  logout({commit, dispatch}) {
    commit('clearAuthData')
    router.replace({name: 'login'})
  },
  
  setTimerForTokenRefresh({dispatch}, expiresIn) {
    let interval = expiresIn - 30
    setInterval(() => {
      // dispatch('tryToRefreshToken')
    }, interval) // 1 minute earlier than expires
  }
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js